import React from 'react';
import cx from 'classnames';
import { string, func } from 'prop-types';
import { Link } from 'react-router';

import CloseIcon from 'icons/close.inline.svg';
import ChevronIcon from 'icons/chevron.inline.svg';

import styles from './NavigationBar.scss';

export default function NavigationBar({ closeTo, handleClose, backTo, title, titleClass }) {
  const CloseButton = () => {
    if (closeTo && !handleClose) {
      return (
        <Link to={closeTo} disabled={!closeTo} className={cx(styles.iconLink, styles.close)}>
          <span>close</span>
          <CloseIcon className={styles.icon} />
        </Link>
      );
    }
    if (handleClose && !closeTo) {
      return (
        <button onClick={handleClose} className={cx(styles.iconLink, styles.close)}>
          <span>close</span>
          <CloseIcon className={styles.icon} />
        </button>
      );
    }
    return null;
  };

  return (
    <header className={styles.main}>
      {backTo &&
        <Link to={backTo} className={cx(styles.iconLink, styles.backTo)}>
          <ChevronIcon className={styles.icon} />
          <span>
            {title}
          </span>
        </Link>}

      {!backTo &&
        <h1 className={cx(styles.title, titleClass)}>
          {title}
        </h1>}

      <CloseButton />
    </header>
  );
}

NavigationBar.propTypes = {
  closeTo: string,
  handleClose: func,
  backTo: string,
  title: string,
  titleClass: string,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/NavigationBar/index.js